import Button from './Button';
import * as buttonStyles from './button.styles';

export default Button;

export { buttonStyles };
